import { Component, input, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-identity-info-title',
    templateUrl: './identity-info-title.component.html',
    styleUrl: './identity-info-title.component.scss',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [],
})
export class IdentityInfoTitleComponent {
    identityName = input.required<string>();
    mpiId = input.required<string>();
    highlightedName = input<boolean>(false);
}
